import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import {unmountComponentAtNode} from 'react-dom';
import {loadwidgate,getcolval,sets,arrengeobj,setusersinactiondv ,showhidediv,setdvl} from './userdefaultdata';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';

export const getsubusr=(txt:any)=>{
var userchats = [
		 {mid:0, mpid:0, mupoints:0, mofferid:0,muname:"", mudob:"",mutypeid:0,upfpid:0,isf:"0",msgalow:0},
		 
		];
const clcd = '#ffff';
if(txt) userchats = txt;
return(
     <div>
      <div className="per100" id="postmain">
	 <div className="postinchat" style={{overflowX:'hidden',overflowY:'auto',height:'',top:'2vh'}}>
	  <div className="postingchatdiv">

	    <table className="postingtable">
		
		
		
		<tbody>
			{userchats.map((row,index)=>(
			<tr>
			   <td className="pfptd" style={{height:'30px'}}>
                         <a href="#"  onClick={e=>showchatroom(e,row.mid,row.muname)}>
                            <div className="cuserid" style={{fontSize:'25px'}}>
                            <div className="chtlnpfp">
				{row.isf=="1"?(
	  			<Girlspfp  itemid={row.upfpid} wth={'40px'}  hgt={'60px'}/>

          			):(
          			<Boyspfp  itemid={row.upfpid} wth={'40px'}  hgt={'60px'}/>

				)}

			    </div>
   			    <div style={{color:clcd}} className="txtlnpfp">
			   	{row.muname}
			    </div>
                            </div>
			</a>
		           </td>
                          
			</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>

     </div>
);

}
export const gstchaddtoboat=(chats:any)=>{
}


export const chtlnpfp = (props:any) => {
    
      return (

       <div>
	{props.isf?(
	  <img src={usrf1} className="c-pfp-img" />
          ):(
          <img src={usrm1} className="c-pfp-img" />
	)}
	
       </div>	
    
   
      );

};

export const showchatroom=(e:any,id:any,name:any)=>{
	const sbusrs = Usersession.getsubusers();
        const userid = Usersession.setUserId(id);

	const user = getcolval(sbusrs,'mid',id);
     
        let objuser = {mid:0,mpid:0,mupoints:0,mofferid:0,muname:"",mudob:"",mutypeid:0,upfpid:0,msgalow:0};
        let objuser1 = user[1];
        
      
        let pf = Usersession.getUserpfp();
        let pfp = arrengeobj(objuser1,pf);
        //alert(JSON.stringify(pf));
        if(pfp.msgalow){
	Usersession.setMsgallow(pfp.msgalow);
	}
	 Usersession.setUserpfp(pf);
        sets('NA','NA',name,'NA');
        const currentvillaid = Usersession.getVillaId();
         if(currentvillaid > 0){
                  setdvl();
	         setusersinactiondv(currentvillaid,false);
        }else{
	loadwidgate('container',5);
       }
        Usersession.setSubuserstatus(0);

	        showhidediv(true,'Subusdv');
	        showhidediv(true,'wigtarea');

               

}